// extracted by css-extract-rspack-plugin
export default {"vacancySkillList":"vacancy-skill-list--JsTYRZ5o6dsoavK7","vacancySkillListMore":"vacancy-skill-list-more--yW9sZG6niFMXVJx8"};